export default "__VITE_ASSET__yNOL_J5e__"